import React from 'react';
import PropTypes from 'prop-types';

const BookIcon = props => {
    const { className, style } = props;

    return (
        <svg
            className={className}
            style={style}
            width="139px"
            height="94px"
            viewBox="0 0 139 94"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g id="layout" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="main_dark"
                    transform="translate(-649.000000, -174.000000)"
                    fillRule="nonzero"
                >
                    <g id="books" transform="translate(649.000000, 159.000000)">
                        <g
                            id="Group-16"
                            transform="translate(40.500000, 65.000000) scale(-1, 1) translate(-40.500000, -65.000000) translate(0.000000, 21.000000)"
                        >
                            <g id="book">
                                <path
                                    d="M3.1137931,57.1913793 L17.9682651,2.85689655 C18.3112296,0.989229672 20.0908291,-0.256566707 21.9630927,0.0603448276 L70.6155172,9.56896552 C76.7014847,10.5554605 81.1276131,15.879324 80.9862069,22.0431034 C80.9627524,22.5726998 80.9051616,23.1002317 80.8137931,23.6224138 L71.2327586,77.9568966 L3.1137931,57.1913793 Z"
                                    id="Shape"
                                    fill="#44D7B6"
                                />
                                <path
                                    d="M51.2647885,50.9262008 C51.1635774,50.9263116 51.0625707,50.9170767 50.9630643,50.898579 L25.4940988,46.4140962 C24.5777587,46.2282638 23.9765288,45.3459231 24.1388037,44.425119 C24.3010785,43.504315 25.1677124,42.8806583 26.0923747,43.0192686 L51.5630643,47.5020272 C52.448948,47.6517305 53.0713811,48.4566307 52.9934131,49.351685 C52.9154452,50.2467391 52.1632138,50.9318926 51.2647885,50.9262008 L51.2647885,50.9262008 Z"
                                    id="Shape"
                                    fill="#FFFFFF"
                                />
                                <path
                                    d="M52.9630643,42.898579 L34.4940988,39.4140962 C33.5777587,39.2282638 32.9765288,38.3459231 33.1388037,37.425119 C33.3010785,36.504315 34.1677124,35.8806583 35.0923747,36.0192686 L53.5630643,39.5020272 C54.448948,39.6517305 55.0713811,40.4566307 54.9934131,41.351685 C54.9154452,42.2467391 54.1632138,42.9318926 53.2647885,42.9261652 C53.1635774,42.9263116 53.0625707,42.9170767 52.9630643,42.898579 Z"
                                    id="Shape-Copy"
                                    fill="#FFFFFF"
                                />
                                <path
                                    d="M80.9827586,22.0344828 C80.9622303,22.5665834 80.9046193,23.0966048 80.8103448,23.6206897 L71.2241379,77.9482759 L57.9310345,73.8965517 L65.637931,30.2068966 L67.4655172,19.8965517 L69.3275862,9.34482759 L70.6206897,9.56896552 C76.6995119,10.5595556 81.1196831,15.8769995 80.9827586,22.0344828 L80.9827586,22.0344828 Z"
                                    id="Shape"
                                    fill="#45C8AB"
                                />
                                <path
                                    d="M61.0344828,63.8965517 L7.10344828,54.3965517 C6.90413,54.3622264 6.70225241,54.3448276 6.5,54.3448276 C4.71298828,54.3493595 3.22553172,55.7183514 3.07304569,57.4988512 C2.92055948,59.2793509 4.15357517,60.8813303 5.9137931,61.1896552 L60.2413793,70.7586207 C61.7687571,71.0352152 63.0924243,71.9803259 63.8499297,73.3351591 C64.6074348,74.6899924 64.7194022,76.3125805 64.1551724,77.7586207 C63.185239,80.0830264 60.7121733,81.4024755 58.2413793,80.9137931 L4.12068966,71.3793103 C3.92137138,71.344985 3.71949379,71.3276812 3.51724138,71.3275862 C1.72692224,71.3231767 0.231022931,72.6896147 0.0737955172,74.4730221 C-0.0834317241,76.2564293 1.15031793,77.8635166 2.9137931,78.1724138 L57.2586207,87.7413793 C60.6815064,88.3414421 64.1970274,87.4384866 66.9070676,85.2631924 C69.6171076,83.0878984 71.2591843,79.8509552 71.4137931,76.3793103 C71.5491166,70.212919 67.1220443,64.8886659 61.0344828,63.8965517 L61.0344828,63.8965517 Z"
                                    id="Shape"
                                    fill="#38AC92"
                                />
                                <path
                                    d="M64.1551724,77.7586207 C63.185239,80.0830264 60.7121733,81.4024755 58.2413793,80.9137931 L4.12068966,71.3793103 L5.9137931,61.1896552 L60.2413793,70.7586207 C61.7687571,71.0352152 63.0924243,71.9803259 63.8499297,73.3351591 C64.6074348,74.6899924 64.7194022,76.3125805 64.1551724,77.7586207 L64.1551724,77.7586207 Z"
                                    id="Shape"
                                    fill="#C8D6DB"
                                />
                            </g>
                        </g>
                        <g
                            id="search"
                            transform="translate(92.475528, 50.845492) rotate(-18.000000) translate(-92.475528, -50.845492) translate(51.975528, 10.845492)"
                        >
                            <path
                                d="M51.3133333,52.4318519 C50.9694861,52.4322522 50.6396831,52.2954786 50.397037,52.0518519 L47.0251852,48.6814815 C46.5189242,48.1752205 46.5189242,47.3544092 47.0251852,46.8481481 C47.5314462,46.3418871 48.3522575,46.3418871 48.8585185,46.8481481 L52.2303704,50.2222222 C52.6008356,50.592949 52.7116147,51.1502805 52.511085,51.6345022 C52.3105553,52.1187239 51.8381759,52.4345533 51.3140741,52.4348148 L51.3133333,52.4318519 Z"
                                id="Path"
                                fill="#319C84"
                            />
                            <path
                                d="M28.1577778,-1.31450406e-13 C43.6107051,-1.31450406e-13 56.1377778,12.5270727 56.1377778,27.98 C56.1377778,43.4329273 43.6107051,55.96 28.1577778,55.96 C12.7048505,55.96 0.177777778,43.4329273 0.177777778,27.98 C0.177777778,12.5270727 12.7048505,-1.31450406e-13 28.1577778,-1.31450406e-13 Z M28.1577778,4.8237037 C15.3689085,4.8237037 5.00148148,15.1911307 5.00148148,27.98 C5.00148148,40.7688693 15.3689085,51.1362963 28.1577778,51.1362963 C40.9466471,51.1362963 51.3140741,40.7688693 51.3140741,27.98 C51.3140741,15.1911307 40.9466471,4.8237037 28.1577778,4.8237037 Z"
                                id="Combined-Shape"
                                fill="#CCDBDB"
                            />
                            <circle
                                id="Oval"
                                fill="#C6E4ED"
                                opacity="0.465076265"
                                cx="28.1577778"
                                cy="27.98"
                                r="23.1562963"
                            />
                            <path
                                d="M63.8910707,45.9224792 C66.6383747,45.9224792 68.8655046,48.1496091 68.8655046,50.8969131 L68.8655046,76.5589632 C68.8655046,79.3062672 66.6383747,81.5333971 63.8910707,81.5333971 C61.1437668,81.5333971 58.9166369,79.3062672 58.9166369,76.5589632 L58.9166369,50.8969131 C58.9166369,48.1496091 61.1437668,45.9224792 63.8910707,45.9224792 Z"
                                id="Rectangle"
                                fill="#38AC92"
                                transform="translate(63.891071, 63.727938) rotate(-45.000000) translate(-63.891071, -63.727938) "
                            />
                            <path
                                d="M52.7259259,50.1481481 C52.9256374,51.0818061 53.3912817,51.937717 54.0666667,52.6125926 L72.2148148,70.7607407 C73.6953831,72.2397382 75.9435824,72.6332915 77.8385185,71.7451852 C77.6388472,70.8115124 77.1731969,69.9555907 76.4977778,69.2807407 L58.3496296,51.1325926 C56.8689557,49.6537986 54.6208923,49.260269 52.7259259,50.1481481 L52.7259259,50.1481481 Z"
                                id="Path"
                                fill="#46BBA1"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

BookIcon.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
};
BookIcon.defaultProps = {
    className: undefined,
    style: undefined,
};

export default BookIcon;
